import styled from "styled-components/macro";
import tw from "twin.macro";

export const Frame = styled.div``;

export const Header = styled.div`
  ${tw`mt-5`};
`;

export const Item = styled.button<{ active?: boolean }>`
  ${tw`py-0.5 px-0 bg-transparent border-none capitalize inline-block text-blueDarkClr text-xl
    cursor-pointer font-medium m-0 mr-8 relative opacity-50
  `};
  font-family: inherit;

  ${({ active = false }) =>
    active && tw`text-primaryClr opacity-100 cursor-auto`};

  &:last-child {
    ${tw`m-0`};
  }

  &::before {
    ${tw`absolute left-0 bottom-0 w-0 h-0.5 bg-blueDarkClr`};

    content: "";
    transition: width 0.3s ease;
    ${({ active = false }) => active && tw`bg-primaryClr w-full`};
  }

  &:hover::before {
    width: 100%;
  }
`;

export const Body = styled.div`
  ${tw`py-8 px-0`};
`;

export const TimeLine = styled.div`
  ${tw`relative`};

  &::before {
    content: "";
    width: 1px;
    ${tw`absolute h-full top-0 left-1.5 bg-primaryClr `};
  }
`;

export const TimeItem = styled.div`
  ${tw`mb-8 relative pt-2.5 pr-0 pb-0 pl-8 `};

  &:last-child {
    ${tw`mb-0`};
  }

  &::before {
    content: "";
    ${tw`absolute h-3 w-3 left-0 top-3.5 bg-primaryClr rounded-half`};
  }
`;

export const Period = styled.span`
  ${tw`block text-primaryClr font-normal m-0 mb-2.5`};
`;

export const Place = styled.span``;

export const Name = styled.h4`
  ${tw`text-lg capitalize m-0 mb-2.5`};

  ${Place} {
    ${tw`font-normal`};
  }
`;

export const Desc = styled.p`
  ${tw`text-justify`};
`;
